export default "__VITE_ASSET__779dd51d__"